<template>
  <div class="wa-editor">
    <div class="wa-editor-toolbar">
      <div class="wa-toolbar-group" role="toolbar" aria-label="Formatting pesan WhatsApp">
        <button
          type="button"
          class="wa-tool-btn wa-tool-bold"
          title="Tebal (WhatsApp: *teks*)"
          aria-label="Tebal"
          @mousedown.prevent="applyStyle('*')"
        >
          B
        </button>
        <button
          type="button"
          class="wa-tool-btn wa-tool-italic"
          title="Miring (WhatsApp: _teks_)"
          aria-label="Miring"
          @mousedown.prevent="applyStyle('_')"
        >
          I
        </button>
        <button
          type="button"
          class="wa-tool-btn wa-tool-strike"
          title="Coret (WhatsApp: ~teks~)"
          aria-label="Coret"
          @mousedown.prevent="applyStyle('~')"
        >
          S
        </button>
        <button
          type="button"
          class="wa-tool-btn wa-tool-mono"
          title="Monospace (WhatsApp: ```teks```)"
          aria-label="Monospace"
          @mousedown.prevent="applyStyle('```')"
        >
          &lt;/&gt;
        </button>
      </div>

      <div class="wa-toolbar-group wa-toolbar-right">
        <div ref="variableMenu" class="wa-variable-wrap">
          <button
            type="button"
            class="wa-tool-btn wa-tool-text"
            title="Sisipkan variabel personalisasi"
            :aria-expanded="showVariables ? 'true' : 'false'"
            @click.stop="showVariables = !showVariables"
          >
            <i class="fa fa-code"></i>
            Variabel
          </button>
          <div v-if="showVariables" class="wa-variable-menu">
            <div class="wa-variable-head">
              <strong>Variabel personalisasi</strong>
              <span>Disisipkan di posisi kursor</span>
            </div>
            <button
              v-for="item in variables"
              :key="item.key"
              type="button"
              class="wa-variable-item"
              @mousedown.prevent="insertVariable(item)"
            >
              <code>{{ item.token }}</code>
              <span>{{ item.label }}</span>
              <small>{{ item.description }}</small>
            </button>
          </div>
        </div>

        <button
          type="button"
          class="wa-tool-btn wa-tool-text"
          title="Sisipkan emoji"
          @click="toggleEmoji"
        >
          <i class="fa fa-smile-o"></i>
          Emoji
        </button>
      </div>
    </div>

    <div class="wa-editor-body">
      <textarea
        ref="messagebox"
        class="wa-textarea"
        :value="value"
        :placeholder="placeholder"
        data-tour-step="formbgret.2"
        spellcheck="false"
        @input="onInput"
      ></textarea>

      <Emoji
        :open="emojiAttr.open"
        :width="emojiAttr.width"
        :height="emojiAttr.height"
        searchLabel="Cari emoji..."
        style="z-index: 9999"
        @click="insertEmoji"
      />
    </div>

    <div class="wa-editor-footer">
      <span class="wa-format-hint">
        <i class="fa fa-info-circle"></i>
        Format tersimpan sebagai teks WhatsApp, bukan HTML.
      </span>
      <span class="wa-character-count" :class="{ 'is-over': overLimit }">
        {{ messageLength }} / {{ maxCount }}
      </span>
    </div>
  </div>
</template>

<script>
import { VueChatEmoji } from "vue-chat-emoji";

export default {
  name: "MomentMessageEditor",
  components: {
    Emoji: VueChatEmoji
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Tulis ucapan atau promo untuk pelanggan..."
    },
    maxCount: {
      type: Number,
      default: 1024
    }
  },
  data() {
    return {
      showVariables: false,
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      variables: [
        { key: "first_name", token: "${first_name}", label: "Nama depan", description: "Nama depan kontak penerima." },
        { key: "last_name", token: "${last_name}", label: "Nama belakang", description: "Nama belakang kontak penerima." },
        { key: "phone_number", token: "${phone_number}", label: "Nomor WhatsApp", description: "Nomor WhatsApp kontak." },
        { key: "email", token: "${email}", label: "Email", description: "Email kontak jika tersedia." },
        { key: "month_current", token: "${month_current}", label: "Bulan saat ini", description: "Nomor bulan berjalan." },
        { key: "month_current_name", token: "${month_current_name}", label: "Nama bulan", description: "Nama bulan berjalan dalam bahasa Indonesia." },
        { key: "year_current", token: "${year_current}", label: "Tahun saat ini", description: "Tahun berjalan." },
        { key: "today", token: "${today}", label: "Tanggal hari ini", description: "Tanggal pada hari pengiriman." },
        { key: "yesterday", token: "${yesterday}", label: "Tanggal kemarin", description: "Tanggal satu hari sebelumnya." },
        { key: "month_ago", token: "${month_ago}", label: "Bulan lalu", description: "Nomor bulan sebelumnya." },
        { key: "month_ago_name", token: "${month_ago_name}", label: "Nama bulan lalu", description: "Nama bulan sebelumnya." },
        { key: "year_ago", token: "${year_ago}", label: "Tahun lalu", description: "Tahun sebelumnya." }
      ]
    };
  },
  computed: {
    messageLength() {
      return String(this.value || "").length;
    },
    overLimit() {
      return this.messageLength > this.maxCount;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
    },
    handleOutsideClick(event) {
      if (!this.showVariables) return;
      if (this.$refs.variableMenu && this.$refs.variableMenu.contains(event.target)) {
        return;
      }
      this.showVariables = false;
    },
    focusEditor() {
      this.$nextTick(() => {
        if (this.$refs.messagebox) {
          this.$refs.messagebox.focus();
        }
      });
    },
    setCursor(position) {
      this.$nextTick(() => {
        const textarea = this.$refs.messagebox;
        if (!textarea) return;
        textarea.focus();
        textarea.setSelectionRange(position, position);
      });
    },
    replaceSelection(insertValue) {
      const textarea = this.$refs.messagebox;
      if (!textarea) return;
      const start = textarea.selectionStart || 0;
      const end = typeof textarea.selectionEnd === "number" ? textarea.selectionEnd : start;
      const current = String(this.value || "");
      const nextValue = current.slice(0, start) + insertValue + current.slice(end);
      this.$emit("input", nextValue);
      this.setCursor(start + insertValue.length);
    },
    insertVariable(item) {
      this.showVariables = false;
      this.replaceSelection(item.token);
    },
    applyStyle(symbol) {
      const textarea = this.$refs.messagebox;
      if (!textarea) return;
      const current = String(this.value || "");
      const start = textarea.selectionStart || 0;
      const end = typeof textarea.selectionEnd === "number" ? textarea.selectionEnd : start;
      const selected = current.slice(start, end);
      const wrapped = symbol + selected + symbol;
      const nextValue = current.slice(0, start) + wrapped + current.slice(end);
      this.$emit("input", nextValue);

      this.$nextTick(() => {
        const nextStart = start + symbol.length;
        const nextEnd = selected ? end + symbol.length : nextStart;
        textarea.focus();
        textarea.setSelectionRange(nextStart, nextEnd);
      });
    },
    toggleEmoji() {
      this.emojiAttr.open = !this.emojiAttr.open;
      if (this.emojiAttr.open) {
        this.showVariables = false;
        this.emojiAttr.width = "100%";
        this.emojiAttr.height = "260px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }
    },
    insertEmoji(args) {
      const emoji = args && args.emoji ? args.emoji : "";
      if (!emoji) return;
      this.replaceSelection(emoji);
      this.emojiAttr.open = false;
      this.emojiAttr.width = "0%";
      this.emojiAttr.height = "0px";
    }
  }
};
</script>

<style scoped>
.wa-editor {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e4eaf2;
  border-radius: 12px;
}

.wa-editor-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  padding: 8px 10px;
  background: #f8fafc;
  border-bottom: 1px solid #e9eef5;
}

.wa-toolbar-group {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.wa-toolbar-right {
  margin-left: auto;
}

.wa-tool-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e4eaf2;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
}

.wa-tool-btn:hover,
.wa-tool-btn:focus {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f2ce91;
  outline: none;
}

.wa-tool-bold { font-weight: 800; }
.wa-tool-italic { font-style: italic; font-family: Georgia, serif; }
.wa-tool-strike { text-decoration: line-through; }
.wa-tool-mono { font-family: Consolas, Monaco, monospace; font-size: 11px; }
.wa-tool-text { padding: 0 10px; font-weight: 600; }

.wa-variable-wrap {
  position: relative;
}

.wa-variable-menu {
  position: absolute;
  top: calc(100% + 7px);
  right: 0;
  z-index: 1200;
  width: 320px;
  max-height: 360px;
  overflow-y: auto;
  padding: 8px;
  background: #ffffff;
  border: 1px solid #e4eaf2;
  border-radius: 12px;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.16);
}

.wa-variable-head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 7px 8px;
}

.wa-variable-head strong {
  color: #344054;
  font-size: 12px;
}

.wa-variable-head span {
  color: #98a2b3;
  font-size: 11px;
}

.wa-variable-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 2px;
  width: 100%;
  padding: 8px 9px;
  text-align: left;
  background: transparent;
  border: 0;
  border-radius: 8px;
}

.wa-variable-item:hover,
.wa-variable-item:focus {
  background: #fffaf0;
  outline: none;
}

.wa-variable-item code {
  color: #b36b00;
  font-size: 11px;
  font-family: Consolas, Monaco, monospace;
}

.wa-variable-item span {
  color: #344054;
  font-size: 12px;
  font-weight: 600;
}

.wa-variable-item small {
  color: #98a2b3;
  font-size: 11px;
  line-height: 1.35;
}

.wa-editor-body {
  position: relative;
}

.wa-textarea {
  display: block;
  width: 100%;
  min-height: 280px;
  padding: 14px 15px;
  color: #344054;
  background: #ffffff;
  border: 0;
  outline: none;
  resize: vertical;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.65;
}

.wa-textarea::placeholder {
  color: #98a2b3;
}

.wa-editor-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  padding: 8px 12px;
  color: #98a2b3;
  background: #fbfcfe;
  border-top: 1px solid #eef2f6;
  font-size: 11px;
}

.wa-format-hint i {
  margin-right: 4px;
  color: #2e90fa;
}

.wa-character-count {
  margin-left: auto;
  font-weight: 600;
}

.wa-character-count.is-over {
  color: #b42318;
}

@media (max-width: 767px) {
  .wa-editor-toolbar {
    align-items: flex-start;
  }

  .wa-toolbar-right {
    margin-left: 0;
  }

  .wa-variable-menu {
    right: auto;
    left: 0;
    width: min(320px, calc(100vw - 54px));
  }

  .wa-textarea {
    min-height: 230px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/automation/birthdayGreetings/components/MomentMessageEditor.vue